import { render, staticRenderFns } from "./BiometricAuthLogin.vue?vue&type=template&id=9bb46080"
import script from "./BiometricAuthLogin.vue?vue&type=script&lang=ts"
export * from "./BiometricAuthLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports